import { render, staticRenderFns } from "./chat-message.vue?vue&type=template&id=2f6326ef&scoped=true"
import script from "./chat-message.vue?vue&type=script&lang=js"
export * from "./chat-message.vue?vue&type=script&lang=js"
import style0 from "./chat-message.vue?vue&type=style&index=0&id=2f6326ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6326ef",
  null
  
)

export default component.exports